<dialog
  #dialog
  qai-dialog
  [heading]="i18nKeys.modalHeading | transloco"
  [description]="step() === 2 ? selectedAssignmentName() : ''"
  (afterClose)="onCancel()"
>

  <!-- Step 1 — Select assignment -->
  @if (step() === 1) {
    <qai-field [label]="i18nKeys.fieldLabelAssignment | transloco">
      <qai-floating-select
        [class.has-value]="!!selectedAssignmentUuid()"
        [shape]="'rectangle'"
        [options]="assignmentOptions()"
        [value]="selectedAssignmentUuid()"
        [placeholder]="i18nKeys.searchAssignmentsPlaceholder | transloco"
        [searchable]="true"
        startIcon="search-lg"
        (valueChange)="onAssignmentSelect($event)"
      />
    </qai-field>

    <div class="action-button-container">
      <button
        qai-button
        kind="secondary"
        size="medium"
        (click)="onCancel()"
      >
        {{ i18nKeys.buttonCancel | transloco }}
      </button>
      <button
        qai-button
        kind="primary"
        size="medium"
        [disabled]="!canProceed()"
        (click)="onNextStep()"
      >
        {{ i18nKeys.buttonSetTeamAssociation | transloco }}
      </button>
    </div>
  }

  <!-- Step 2 — Select teams -->
  @if (step() === 2) {
    <qai-field [label]="i18nKeys.fieldLabelTeam | transloco">
      <qai-multiselect
        [options]="teamOptions()"
        [value]="selectedTeamUuids()"
        [placeholder]="i18nKeys.searchTeamPlaceholder | transloco"
        [startIcon]="selectedTeamUuids().length ? 'search-lg' : undefined"
        (valueChange)="onTeamSelectionChange($event)"
      />
    </qai-field>

    <div class="action-button-container">
      <button
        qai-button
        kind="secondary"
        size="medium"
        (click)="onCancel()"
      >
        {{ i18nKeys.buttonCancel | transloco }}
      </button>
      <button
        qai-button
        kind="primary"
        size="medium"
        [disabled]="!canAssign() || isSaving()"
        (click)="onAssign()"
      >
        {{ i18nKeys.buttonAddToAssignment | transloco }}
      </button>
    </div>
  }

</dialog>
